<template>
  <div class="hs-tool">
    <div class="editor-pane">
      <div class="pane-header"><span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.HttpStatus.title') }}</span></div>
      <el-input v-model="keyword" size="small" :placeholder="$t('tool.HttpStatus.search')" clearable prefix-icon="el-icon-search" class="hs-search" />
    </div>
    <div class="editor-pane" v-for="g in filtered" :key="g.range">
      <div class="hs-group-hd">{{ g.range }} — {{ g.desc }}</div>
      <div class="hs-grid">
        <div v-for="item in g.items" :key="item.code" class="hs-item">
          <code class="hs-code">{{ item.code }}</code>
          <span class="hs-name">{{ item.name }}</span>
          <span class="hs-desc">{{ item.desc }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var CAT_KEYS = { '1xx':'info', '2xx':'success', '3xx':'redirect', '4xx':'clientError', '5xx':'serverError' }
var ITEMS = {
  '1xx':[{code:100,name:'Continue'},{code:101,name:'Switching Protocols'},{code:102,name:'Processing'},{code:103,name:'Early Hints'}],
  '2xx':[{code:200,name:'OK'},{code:201,name:'Created'},{code:202,name:'Accepted'},{code:204,name:'No Content'},{code:206,name:'Partial Content'}],
  '3xx':[{code:301,name:'Moved Permanently'},{code:302,name:'Found'},{code:304,name:'Not Modified'},{code:307,name:'Temporary Redirect'},{code:308,name:'Permanent Redirect'}],
  '4xx':[{code:400,name:'Bad Request'},{code:401,name:'Unauthorized'},{code:403,name:'Forbidden'},{code:404,name:'Not Found'},{code:405,name:'Method Not Allowed'},{code:408,name:'Request Timeout'},{code:409,name:'Conflict'},{code:410,name:'Gone'},{code:413,name:'Payload Too Large'},{code:415,name:'Unsupported Media Type'},{code:422,name:'Unprocessable Entity'},{code:429,name:'Too Many Requests'}],
  '5xx':[{code:500,name:'Internal Server Error'},{code:501,name:'Not Implemented'},{code:502,name:'Bad Gateway'},{code:503,name:'Service Unavailable'},{code:504,name:'Gateway Timeout'}]
}
export default {
  name:'HttpStatusTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({keyword:''}),
  computed:{
    data(){ var cats=this.$t('tool.HttpStatus.categories'); return Object.keys(ITEMS).map(function(k){return{range:k,desc:cats[CAT_KEYS[k]],items:ITEMS[k]}}) },
    filtered(){ var kw=this.keyword.trim(); var d=this.data; if(!kw)return d; return d.map(function(g){return{range:g.range,desc:g.desc,items:g.items.filter(function(i){return String(i.code).includes(kw)||i.name.toLowerCase().includes(kw.toLowerCase())})}}).filter(function(g){return g.items.length}) }
  },
  methods:{doAction(a){if(a==='clear')this.keyword=''}}
}
</script>

<style scoped>
.hs-tool { display:flex;flex-direction:column;gap:12px; }
.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:14px 20px; }
.pane-header { display:flex;align-items:center;gap:8px;margin-bottom:10px; }
.pane-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0; }
.input-dot { background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4); }
.pane-label { font-size:13px;font-weight:700;color:#1a1f36; }
.hs-group-hd { font-size:12px;font-weight:700;color:#8892a6;margin-bottom:8px; }
.hs-grid { display:flex;flex-direction:column;gap:4px; }
.hs-item { display:flex;align-items:center;gap:12px;padding:6px 0;border-bottom:1px solid #f5f6f8; }
.hs-item:last-child { border-bottom:none; }
.hs-code { font-family:monospace;font-size:14px;font-weight:700;color:#4e7cff;width:44px; }
.hs-name { font-size:13px;color:#303133;width:180px; }
.hs-desc { font-size:12px;color:#8892a6; }
</style>
